


































import { Component, Vue, Prop } from 'vue-property-decorator'
import _PaymentIQCashier from 'paymentiq-cashier-bootstrapper'
import Cashier from '@/components/Cashier'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'


@Component({
  components: {
    Cashier
  },
  computed: {
    ...mapState({
      customCss: ({ cashierContext }: any): string => cashierContext.customCss,
      autoProcessProvider: ({ cashierContext }: any): string => cashierContext.autoProcessProvider
    })
  }
})

export default class QuickDeposit extends Vue {
  @Action('setTheme') setTheme: any

  @Prop({ type: Function, required: false }) closeDialog!: any

  spinner: boolean = false
  customCss!: string
  autoProcessProvider!: string
  $cashierConfigs!: any

  private customFunction (data: any): void {
    switch (data) {
      case 'isHidden':
        this.spinner = true
        break
      case 'isVisible':
        this.spinner = false
        break
      case 'done':
        this.closeDialog()
        break
      default:
        break
    }
  }

  private created (): void {
    this.$cashierConfigs('quickDeposit')
  }
}
